import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  headerContainer: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 1077,
    marginBottom: '16px',
  }),

  numText: css({
    display: 'flex',
    flexDirection: 'column',
    color: colors.oxfordBlue,
    fontSize: '20px',
    lineHeight: '120%',
    fontWeight: fontWeight.normal,
    marginBottom: '16px',

    p: {
      marginTop: 3,
      marginBottom: 0,
    },

    a: {
      color: '#2f96f4',
      textDecoration: 'underline',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      fontWeight: fontWeight.semiBold,
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
      fontWeight: fontWeight.medium,
      fontSize: fontSize.default,
      lineHeight: '17px',
      marginBottom: 0,

      p: {
        margin: '0 0 16px',
        marginLeft: 2,
      },

      a: {
        fontWeight: fontWeight.medium,
        textDecoration: 'none',
      },
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      p: {
        margin: 0,
      },
    },
  }),

  boldText: css({
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.large,
    lineHeight: '140%',
    color: '#132254',

    [mediaQueryHelper(breakpoint.phone)]: {
      fontWeight: fontWeight.bold,
    },
  }),

  normalText: css({
    fontWeight: fontWeight.regular,
  }),

  subText: css({
    display: 'flex',
    flexDirection: 'column',
    color: colors.scorpion,
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
    lineHeight: '140%',
    marginTop: 6,

    a: {
      color: colors.amethyst,
    },

    p: {
      margin: 0,
      marginBottom: 6,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      flexDirection: 'row',
      fontWeight: fontWeight.medium,

      p: {
        margin: 0,
      },
    },
  }),

  questionText: css({
    display: 'none',

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',

      img: {
        marginLeft: 4,
      },
    },
  }),

  popUp: css({
    padding: '14px',
    fontSize: fontSize.default,
    lineHeight: '140%',
    fontWeight: fontWeight.regular,
    color: colors.blackPearl,

    a: {
      fontWeight: fontWeight.bold,
      color: colors.cornflowerBlue,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  }),

  modal: css({
    width: '270px',
    left: 0,
    top: 'calc(100% + 6px)',
    [mediaQueryHelper(breakpoint.phone)]: {
      width: '310px',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '340px',
    },
  }),
}

export default styles
